import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/codebuild/output/src1723499913/src/own-your-mindset-map/layouts/default.vue").then(m => m.default || m))
}